import React from 'react';
import './Footer.css';

// ✏️ PLACEHOLDER: Update footer info
const FOOTER_DATA = {
  year: new Date().getFullYear(),
  name: 'M. Faheem Khan',
  logoName: 'FAHEEM GRAPHICS', // Separate logo text
  tagline: 'Digital Product Designer and Animator',
  // 🔗 PLACEHOLDER: Replace # with real URLs
  logoLink: '/', // Link for logo
  socials: [
    { label: 'Facebook', href: 'https://www.facebook.com/share/1Dbaf3b7Ri/', icon: 'fab fa-facebook-f' },
    { label: 'Instagram', href: 'https://www.instagram.com/faheem_graphics123?igsh=MXF6ajN3bXhyZnUweA==', icon: 'fab fa-instagram' },
    { label: 'Behance', href: 'https://www.behance.net/faheem_graphics', icon: 'fab fa-behance' },
    { label: 'Vimeo', href: 'https://vimeo.com/faheemgrahics', icon: 'fab fa-vimeo-v' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/muhammad-faheem-khan-3029541bb/', icon: 'fab fa-linkedin-in' },
  ],
  credits: 'Talha Khalid', // 🔗 PLACEHOLDER: Your theme / template credit
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        {/* Logo - Centered and Clickable */}
        <a href="/" className="navbar-logo">
          <img src="/images/FG-Logo.png" alt="Faheem Graphics" />
        </a>

        {/* Social Icons - Centered */}
        <div className="footer-social">
          {FOOTER_DATA.socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
            >
              <i className={s.icon}></i>
            </a>
          ))}
        </div>

        {/* Copyright and Credits - Centered */}
        <div className="footer-rights">
          <p className="footer-copyright">
            © {FOOTER_DATA.year} All rights reserved by {FOOTER_DATA.name}.
          </p>
          <p className="footer-designed">
            Developed by{' '}
            <a href="https://www.talhakhaliddhariwal.me" target='_blank' className="footer-credit">{FOOTER_DATA.credits}</a>
          </p>
        </div>
      </div>
    </footer>
  );
}